import {
    Background,
    BackgroundColor,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../components/layout"

import React from "react"
import classNames from "classnames"
import { types } from "react-bricks/frontend"

export interface SpacerProps {
    mobileOnly?: boolean
    background: { color: BackgroundColor } | BackgroundColor
    variant?: SpacerVariant
}

const SpacerComponent: types.Brick<SpacerProps> = ({ background, mobileOnly, variant }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <div className={classNames("w-full", { "block sm:hidden": mobileOnly })} aria-hidden="true">
            <Background color={bgColor}>
                <Spacer variant={variant} />
            </Background>
        </div>
    )
}

SpacerComponent.schema = {
    name: "Spacer",
    label: "Spacer Component",
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            name: "variant",
            label: "Spacer Variant",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: spacerOptions,
                display: types.OptionsDisplay.Select,
            },
        },
        {
            name: "mobileOnly",
            label: "Mobile Only",
            type: types.SideEditPropType.Boolean,
        },
    ],
    getDefaultProps: () => ({
        background: { color: BackgroundColor.White },
        mobileOnly: false,
        variant: SpacerVariant.Base,
    }),
}

export default SpacerComponent
